
<template>
    <div class="user_main_settings">
        <div class="row pt-5">
            <div class="col-lg-4 col-md-4 col-xs-12 col-xl-4 pb-4">
                <div class="panel-tag">
                    Редагування профілю
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Назва компанії</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> НК </span>
                        </div>
                        
                        <BFormInput :disabled="true" v-model="user_company" class="form-control"></BFormInput>
                    </div>
                </div>
                
                
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Код ЄДРПОУ компанії</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> КЭ </span>
                        </div>
                        
                        <BFormInput :disabled="true" v-model="user_edrpou" class="form-control"></BFormInput>
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Контактний номер телефону</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> - </span>
                        </div>
                        
                        <BFormInput
                            type="mobile"
                            v-mask="'+38 (###) ###-##-##'"
                            placeholder="+38 (###) ###-##-##"
                            id="mobile-input-group"
                            v-model="user_phone"
                            :state="validPhone" required/>
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Контактна особа</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> - </span>
                        </div>
                        
                        <BFormInput :state="validContUser"  v-model="contact_name" class="form-control"></BFormInput>
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Адреса електронної пошти</label>
                    <div class="input-group">
                        <div class="input-group-prepend">
                            <span class="input-group-text"> - </span>
                        </div>
                        <BFormInput :disabled="true"  v-model="this.user.email" class="form-control"></BFormInput>
                    </div>
                </div>
                
                <div class="form-group mt-2">
                    <label class="form-label" for="basic-url">Вимкнути розсилку анонсів тендерів</label>
                    <yes_no v-model="settings.subscription_deactivated"></yes_no>
                </div>
                
            </div>
        </div>
        
        <div class="row justify-content-between pt-5">
            <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
                <button class="btn btn-lg btn-block btn-outline-success waves-effect waves-themed"
                        :disabled="!is_save_inactive"
                        v-on:click="save">
                    <span class="fal fa-download mr-1"></span>
                    Зберегти
                </button>
            </div>
            
            <!--
            <div class="next_step col-xs-12 col-lg-4 col-sm-4 col-xl-3 mt-3">
                <button class="btn btn-lg btn-block btn-danger waves-effect waves-themed"
                        v-on:click="remove">
                    <span class="fal fa-download mr-1"></span>
                    Видалити аккаунт
                </button>
            </div>
            -->
        </div>
    </div>
</template>

<script>
import {mapGetters} from "vuex";
import {
    BFormInput ,
} from 'bootstrap-vue-next';
import Yes_no from "../../../../base/yes_no.vue";

export default {
    name: "profile_edit",
    
    components : {
        Yes_no,
        BFormInput
    },
    emits: ['loading'],
    methods : {
        
        async save() {
             this.$emit('loading','main_settings',true);
            
            await api.put('/tenders/contragent/users/' + this.user_id,this.form).then(({data}) => {
                this.$emit('loading','main_settings',false);
                
                if(data.status === "operation_success") {
                    this.$store.dispatch('user/LOAD_USER');
                }
                
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                this.$emit('loading','main_settings',false);
            });
        },
        
        async remove() {
            let self = this;
            confirm_imc('Видалити?').then(res => {
                self.remove_contragent();
            });
        },
        
        async remove_contragent() {
            await api.delete('/tenders/contragent/users/' + this.user_id).then(({data}) => {
                this.$emit('loading','main_settings',false);
                this.logout();
                
            }).catch(({response}) => {
                EventBus.$emit('show_toast', {err: response.data.message, type: "danger", title: response.data.status})
                this.$emit('loading','main_settings',false);
            });
        },
        
        async logout() {
            IMC_CORE.showloading()
            await axios.post('/internal/api/logout').then(({data}) => {
                window.location.reload();
            }).catch(err => {
                IMC_CORE.hideloading()
                EventBus.$emit('show_toast', {err: err.message, type: "danger", title: err.name})
            });
        },
        
        
    },
    
    computed : {
        
        ...mapGetters({
            'user': "user/getUser",
            'settings' : "user/getUserTenderSettings",
        }),
        
        user_id() {
            return this.user.id;
        },
        
        user_company() {
            return this.settings.company;
        },
        
        user_edrpou() {
            return this.settings.edrpou;
        },
        
        user_phone : {
            get() {
                return this.settings.contact_tel;
            },
            
            set(val)  {
                this.settings.contact_tel = val;
            }
        },
        
        contact_name : {
            get() {
                return this.settings.contact_name;
            },
            
            set(val)  {
                this.settings.contact_name = val;
            }
        },
        
        is_save_inactive () {
            return this.validContUser && this.validPhone;
        },
        
        validContUser() {
            return this.contact_name?.length >= 3;
        },
        
        validPhone() {
            return this.user_phone?.length >= 8;
        },
        
        form() {
          return {
              "phone" : this.user_phone,
              'contact_name' : this.contact_name,
              'subscription_deactivated' : this.settings.subscription_deactivated
          }
        }
        
    }
    
}
</script>


<style scoped>

</style>